import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import MobileHomeRightPane from './MobileHomeRightPane'
import AnchorLink from 'react-anchor-link-smooth-scroll'

import Button from '@material-ui/core/Button';
import Hidden from '@material-ui/core/Hidden'

// import MenuIcon from '@material-ui/icons/Menu';
// import IconButton from '@material-ui/core/IconButton';
// import { Language } from '@material-ui/icons';



import './header.css'

export default class RightPane extends Component {
  render() {
    return (
      <React.Fragment>

        <Hidden smDown>
        <AnchorLink className={css(styles.AnchorLink)} offset='-230' href="#Portfolio">
          <Button className={css(styles.MenuButton)}>Portfolio</Button>
        </AnchorLink>
        <AnchorLink className={css(styles.AnchorLink)} offset='-230' href="#StandAloneSolutions">
          <Button className={css(styles.MenuButton)}>Solutions</Button>
        </AnchorLink>
        <AnchorLink className={css(styles.AnchorLink)} offset='-230' href="#MeetTheTeam">
          <Button className={css(styles.MenuButton)}>Team</Button>
        </AnchorLink>
        <AnchorLink className={css(styles.AnchorLink)} offset='80' href="#Achievements">
          <Button className={css(styles.MenuButton)}>Achievements</Button>
        </AnchorLink>
        <AnchorLink className={css(styles.AnchorLink)} offset='-230' href="#Footer">
          <Button className={css(styles.MenuButton)}>Contact</Button>
        </AnchorLink>

        {/*<Button variant="fab" ><Language /></Button>*/}
        </Hidden>
       {/* <IconButton className={css(styles.MenuButton)}>
          <Language />
        </IconButton>*/}
        <Hidden smUp>   
          <MobileHomeRightPane />
        </Hidden>
      </React.Fragment>
    );
  }
}
const styles = StyleSheet.create({
    MenuButton : {
      color: 'white',
      textTransform: 'capitalize'
    },
    AnchorLink: {
      textDecoration: 'none',
    }
});


// WEBPACK FOOTER //
// ./src/Components/Header/HomeRightPane.js